/* eslint-disable no-return-await */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import TotalStreetPage from 'src/pages/ReportsPages/ReportsBoard/MarketShareReportsPages/TotalStreetPage'
import boardReportsService from 'src/services/boardReportsService'
import segmentacionService from 'src/services/segmentacionService'

const MarkertStreetCompany = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [totalStreet, setTotalStreet] = useState([])
  const [totalStreetSegment, setTotalStreetSegment] = useState([])
  const [gTotalStreetA, setGTotalStreetA] = useState([])
  const [gTotalStreetB, setGTotalStreetB] = useState([])
  const [totalSreetZone, setTotalStreetZone] = useState([])
  const [deportives, setDeportives] = useState([])
  const [deportivesSegment, setDeportivesSegmet] = useState([])
  const [deportivesZones, setDeportivesZones] = useState([])
  const [gdeportivesZonesA, setDeportivesZonesA] = useState([])
  const [gdeportivesZonesB, setDeportivesZonesB] = useState([])
  const [transporte, setTransporte] = useState([])
  const [transporteSegment, setTransporteSegmet] = useState([])
  const [transporteZones, setTransporteZones] = useState([])
  const [gtransporteZonesA, setTransporteZonesA] = useState([])
  const [gtransporteZonesB, setTransporteZonesB] = useState([])
  const [gATransportSubSegments, setGATransportSubSegments] = useState([])
  const [gBTransportSubSegments, setGBTransportSubSegments] = useState([])

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadComponents = async () => {
    const [
      totalStreet,
      totalStreetSegment,
      gTotalStreetA,
      gTotalStreetB,
      totalSreetZone,
      deportives,
      deportivesSegment,
      deportivesZones,
      gdeportivesZonesA,
      gdeportivesZonesB,
      transporte,
      transporteSegment,
      transporteZones,
      gtransporteZonesA,
      gtransporteZonesB,
    ] = await Promise.all([
      boardReportsService.getTotalMarketShare('3', selectedDate.getFullYear(), 'subcategoria=STREET'),
      boardReportsService.getTotalMarketShare('4', selectedDate.getFullYear(), 'subcategoria=STREET'),
      boardReportsService.getTotalMarketShareGraphics('4a', selectedDate.getFullYear(), 'subcategoria=STREET'),
      boardReportsService.getTotalMarketShareGraphics('4b', selectedDate.getFullYear(), 'subcategoria=STREET'),
      boardReportsService.getTotalMarketShare('5', selectedDate.getFullYear(), 'subcategoria=STREET'),
      boardReportsService.getTotalMarketShare(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=STREET&segmento=DEPORTIVAS'
      ),
      boardReportsService.getTotalMarketShare(
        '11',
        selectedDate.getFullYear(),
        'subcategoria=STREET&segmento=DEPORTIVAS'
      ),
      boardReportsService.getTotalMarketShare(
        '12',
        selectedDate.getFullYear(),
        'subcategoria=STREET&segmento=DEPORTIVAS'
      ),
      boardReportsService.getTotalMarketShareGraphics(
        '5a',
        selectedDate.getFullYear(),
        'subcategoria=STREET&segmento=DEPORTIVAS'
      ),
      boardReportsService.getTotalMarketShareGraphics(
        '5b',
        selectedDate.getFullYear(),
        'subcategoria=STREET&segmento=DEPORTIVAS'
      ),
      boardReportsService.getTotalMarketShare(
        '6',
        selectedDate.getFullYear(),
        'subcategoria=STREET&segmento=TRANSPORTE'
      ),
      boardReportsService.getTotalMarketShare(
        '11',
        selectedDate.getFullYear(),
        'subcategoria=STREET&segmento=TRANSPORTE'
      ),
      boardReportsService.getTotalMarketShare(
        '12',
        selectedDate.getFullYear(),
        'subcategoria=STREET&segmento=TRANSPORTE'
      ),
      boardReportsService.getTotalMarketShareGraphics(
        '5a',
        selectedDate.getFullYear(),
        'subcategoria=STREET&segmento=TRANSPORTE'
      ),
      boardReportsService.getTotalMarketShareGraphics(
        '5b',
        selectedDate.getFullYear(),
        'subcategoria=STREET&segmento=TRANSPORTE'
      ),
    ])
    setTotalStreet(totalStreet)
    setTotalStreetSegment(totalStreetSegment)
    setGTotalStreetA(gTotalStreetA)
    setGTotalStreetB(gTotalStreetB)
    setTotalStreetZone(totalSreetZone)
    setDeportives(deportives)
    setDeportivesSegmet(deportivesSegment)
    setDeportivesZones(deportivesZones)
    setDeportivesZonesA(gdeportivesZonesA)
    setDeportivesZonesB(gdeportivesZonesB)
    setTransporte(transporte)
    setTransporteSegmet(transporteSegment)
    setTransporteZones(transporteZones)
    setTransporteZonesA(gtransporteZonesA)
    setTransporteZonesB(gtransporteZonesB)
  }

  const getTransportG = async () => {
    const response = await segmentacionService.getSubSegmentos('2')
    Promise.all(
      response.map(
        async value =>
          await boardReportsService.getTotalMarketShareGraphics(
            '6a',
            selectedDate.getFullYear(),
            `subcategoria=STREET&segmento=TRANSPORTE&subsegmento=${value.subsegmento}`
          )
      )
    ).then(arr => {
      setGATransportSubSegments([arr, response])
    })
  }

  const getTransportGB = async () => {
    const response = await segmentacionService.getSubSegmentos('2')
    Promise.all(
      response.map(
        async value =>
          await boardReportsService.getTotalMarketShareGraphics(
            '6b',
            selectedDate.getFullYear(),
            `subcategoria=STREET&segmento=TRANSPORTE&subsegmento=${value.subsegmento}`
          )
      )
    ).then(arr => {
      setGBTransportSubSegments([arr, response])
    })
  }

  useEffect(() => {
    getTransportG()
    getTransportGB()
  }, [])

  useEffect(() => {
    reloadComponents()
  }, [selectedDate])

  return (
    <TotalStreetPage
      deportives={deportives}
      gATransportSubSegments={gATransportSubSegments}
      gBTransportSubSegments={gBTransportSubSegments}
      totalSreetZone={totalSreetZone}
      deportivesSegment={deportivesSegment}
      deportivesZones={deportivesZones}
      gdeportivesZonesA={gdeportivesZonesA}
      gdeportivesZonesB={gdeportivesZonesB}
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
      totalStreet={totalStreet}
      totalStreetSegment={totalStreetSegment}
      gTotalStreetA={gTotalStreetA}
      gTotalStreetB={gTotalStreetB}
      transporte={transporte}
      transporteSegment={transporteSegment}
      transporteZones={transporteZones}
      gtransporteZonesA={gtransporteZonesA}
      gtransporteZonesB={gtransporteZonesB}
    />
  )
}

export default MarkertStreetCompany
